/**
 * 【员工列表】
 */
import React from 'react';
import { message } from 'antd';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XInput, XOKButton, XCancelButton, XSelect } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableContent from './components/TableContent';
import NoLogin from './modal/NoLogin';
import ResetPassword from './modal/ResetPassword';
import model from '@/reducers/permissions/employee/model';
import http from '@/assets/api/http';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const emplState = [{ code: 1, value: '正常' }, { code: 0, value: '禁用' }];

class Main extends React.Component {

    state = {
        loginName: '', // 员工账号
        emplName: '', // 员工姓名
        tel: '', // 员工电话
        status: {}, // 状态
        dept: {}, // 部门
        OpenModalType: '', // 当前弹框
        openModalParam: '', // 弹框入参
    };

    componentDidMount() {
        this.props.getDeptPullDown({ isNeedSanji: 1, isNeePermissionFilter: 0 });
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    // 查询
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, loginName, emplName, tel, status, dept } = this.state;
        const query = {
            loginName,
            emplName,
            tel,
            status: status.code,
            deptId: dept.id,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getEmplList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ loginName: '', emplName: '', tel: '', status: {}, dept: {}, OpenModalType: '', openModalParam: '' }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格操作
    _tableAction = (type, item) => {
        const { history } = this.props;
        switch (type) {
            case 'edit':
                history.push({
                    pathname: `/home/permissions/employee/operate/edit/${item.id}`
                });
                break;
            case 'disable': // 有两种情况：禁止和启用
                this.setState({ OpenModalType: 'disable', openModalParam: item.id });
                break;
            case 'able':
                http('/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.activeEmpl', { id: item.id }, 'POST').then(() => {
                    message.success('启用成功！');
                    this._searchHandle('useCache');
                }).catch((e) => {
                    message.error(e.message);
                });
                break;
            case 'reset':
                this.setState({ OpenModalType: 'reset', openModalParam: item.id });
                break;
        }
    }

    //打开弹窗
    _renderMode = () => {
        switch (this.state.OpenModalType) {
            case 'disable':
                return <NoLogin id={this.state.openModalParam} closeModal={this._closeModal} />;
            case 'reset':
                return <ResetPassword id={this.state.openModalParam} closeModal={this._closeModal} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ OpenModalType: '' });
        if (update) {
            this._searchHandle('useCache');
        }
    }

    // 新建员工
    _newHandle = () => {
        const { history } = this.props;
        history.push({ pathname: '/home/permissions/employee/operate/add' });
    }

    render() {
        const { loginName, emplName, tel, status, dept } = this.state;
        const { emplList, deptPullDown } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='员工账号'
                                placeholder='请输入员工账号'
                                value={loginName}
                                bindThis={this}
                                bindName='loginName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='员工姓名'
                                placeholder='请输入员工姓名'
                                value={emplName}
                                bindThis={this}
                                bindName='emplName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='手机号码'
                                placeholder='请输入手机号码'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='状态'
                                placeholder='请选择状态'
                                renderData={emplState}
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '300px' }}
                                label='所属部门'
                                placeholder='请选择所属部门'
                                renderData={deptPullDown}
                                dataIndex='deptName'
                                keyIndex='id'
                                value={dept.deptName}
                                bindThis={this}
                                bindName='dept'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.row3}>
                        <XOKButton
                            style={{ width: '100px' }}
                            label='新建员工'
                            onClick={this._newHandle}
                        />
                    </div>
                    <TableContent renderData={emplList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    getEmplList: PropTypes.func, // 获取员工列表
    emplList: PropTypes.object, // 员工列表
    getDeptPullDown: PropTypes.func, // 获取部门下拉列
    deptPullDown: PropTypes.array, // 部门下拉列
    match: PropTypes.object, // router match
    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    emplList: state.employee.getEmplList,
    deptPullDown: state.employee.getDeptPullDown,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);
